import React from 'react';
import PropTypes from 'prop-types';

// Full body, not an excerpt — the point of the workbench is reading exactly what the model was
// given, so truncating here would defeat it.
export default function FragmentDetail({ fragment }) {
  if (!fragment) {
    return <p className="text-muted small">Select a fragment to read its contents.</p>;
  }

  return (
    <div>
      <h6 className="fw-semibold mb-1">{fragment.breadcrumb || fragment.filename}</h6>
      <div className="text-muted small mb-2">
        {fragment.filename}
        {fragment.distance != null && (
          <> · distance <span className="font-monospace">{Number(fragment.distance).toFixed(4)}</span></>
        )}
        {fragment.rank != null && <> · rank {fragment.rank}</>}
      </div>
      <pre
        className="bg-light border rounded p-3 small mb-0"
        style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
      >
        {fragment.body}
      </pre>
    </div>
  );
}

FragmentDetail.propTypes = { fragment: PropTypes.object };
FragmentDetail.defaultProps = { fragment: null };
